export const reducerEshopHeader = (state, action) => {
    switch (action.type) {
        case 'setIsMobile': {
            return Object.assign(Object.assign({}, state), { isMobile: action.payload });
        }
        case 'setSearchText': {
            return Object.assign(Object.assign({}, state), { searchText: action.payload });
        }
        case 'setIsVisibleSearch': {
            return Object.assign(Object.assign({}, state), { isVisibleSearch: action.payload });
        }
        case 'setControlDisplayFromEvent': {
            return Object.assign(Object.assign({}, state), { controlDisplayFromEvent: action.payload });
        }
        case 'setIsSticky': {
            return Object.assign(Object.assign({}, state), { isStickyState: action.payload });
        }
        default: {
            throw new Error(`Unhandled action type`);
        }
    }
};
